import React, {Suspense} from "react";
import ReactDOM from "react-dom";

import {Router, Route, Switch, Redirect} from "react-router-dom";
import "./i18n";
import store from "./store.js";
import {history} from "_helpers/history";
import PrivateRoute from "_helpers/PrivateRoute";
import {Provider} from "react-redux";
import "antd/dist/antd.css";
import reportWebVitals from "./reportWebVitals";
import variables from "_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import Admin from "layout/Admin";
import Auth from "layout/Auth";
import TutorAuth from "layout/TutorAuth";
import NoAuth from "layout/NoAuth";
import 'rsuite/styles/index.less';
import './index.less'

import "./assets/fonts/futura-book.otf";
import "./assets/fonts/futura-bold.woff";
import "./assets/fonts/futura-bold.woff2";
import "./assets/fonts/futura-medium.woff";
import "./assets/fonts/futura-medium.woff2";
import "assets/sass/normal.scss";

const storage = localOrSessionStore({key: variables.REMEMBER});

const Loader = () => {
  return <div>loading...</div>;
};

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Loader />}>
      <Router history={history}>
        <Switch>
          <Route path="/auth" component={Auth} />
          <Route path="/default" component={NoAuth} />
          <Route path="/tutorAuth" component={TutorAuth} />
          <PrivateRoute path="/admin" component={Admin} />
          {storage.getItem(variables.TOKEN) ? (
            <Redirect from="/" to="/default/index" />
          ) : (
            <Redirect from="/" to="/default/index" />
          )}
        </Switch>
      </Router>
    </Suspense>
  </Provider>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
